<article class="ui-card">
  <h3 class="ui-card-title">
    <ng-content select="[cardTitle]" />
  </h3>

  <div class="ui-card-rows">
    <ng-content select="[cardRows]" />
  </div>
</article>
